import AuthService from "../../AuthService";
const location = {
  getLocation(page) {
    return AuthService.get(`/about/location?page=${page}`);
  },
  showLocation(id) {
    return AuthService.get(`/about/location/${id}`);
  },
  createLocation(data) {
    return AuthService.post(`/about/location`,data);
  },
  updateLocation(id, data) {
    return AuthService.put(`/about/location/${id}`,data);
  },
  deleteLocation(id) {
    return AuthService.delete(`/about/location/${id}`);
  }
};
export default location;
